import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import BlogpostSummery from "../components/BlogpostSummery.jsx";
import SmallTitleText from "../components/SmallTitleText.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const NewsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const pageFromUrl = searchParams.get("page");
  const [currentPageNr, setCurrentPageNr] = useState(() => {
    return pageFromUrl ? Number(pageFromUrl) : 1;
  });

  // Sync the page number state with the URL parameter
  useEffect(() => {
    const pageFromUrl = searchParams.get("page");
    if (pageFromUrl && Number(pageFromUrl) !== currentPageNr) {
      setCurrentPageNr(Number(pageFromUrl));
    }
  }, [searchParams]);

  const { data, error, loading } = MakeGetRequest({
    route: `get_news?page=${currentPageNr}`,
  });

  if (data) {
    const itemsToView = 12;
    const totalPages = Math.ceil(data.count / itemsToView);

    const goToNextPage = () => {
      if (currentPageNr < totalPages) {
        setCurrentPageNr((prevPage) => prevPage + 1);
        navigate(`?page=${currentPageNr + 1}`, { replace: true });
      }
    };

    const goToPreviousPage = () => {
      if (currentPageNr > 1) {
        setCurrentPageNr((prevPage) => prevPage - 1);
        navigate(`?page=${currentPageNr - 1}`, { replace: true });
      }
    };
    return (
      <>
        <Layout
          title="Nyheter"
          description="Läs de senaste nyheterna från de band, artister och musiker som finns nära dig"
        >
          <MainContainer>
            <div className="my-8 text-center">
              <SmallTitleText text="Nyheter" />
              <p className="my-2 text-xl">Nyheter från musiker nära dig</p>
              <p className="my-2">
                Om du vill läsa om de senaste från Lokult klicka{" "}
                <a className="text-primary font-semibold" href="/lokult-news">
                  här
                </a>
              </p>
            </div>

            <div className="space-y-12 ">
              {data.items.map((post, index) => (
                <div key={index} className="grid col-span-1 first:mt-2">
                  {index == 6 && (
                    <div className="mb-4 -mt-8 ">
                      <CommercialBanner />
                    </div>
                  )}
                  <BlogpostSummery key={index} post={post} index={index} />
                </div>
              ))}
            </div>
            <div className="w-full flex justify-center my-8">
              {" "}
              <div className="join m-auto">
                <button
                  className="join-item btn"
                  onClick={goToPreviousPage}
                  disabled={currentPageNr === 1}
                >
                  «
                </button>
                <button className="join-item btn">
                  Sida 1 <span className="text-neutral">(av {totalPages})</span>
                </button>
                <button
                  className="join-item btn"
                  onClick={goToNextPage}
                  disabled={currentPageNr === totalPages}
                >
                  »
                </button>
              </div>
            </div>
          </MainContainer>
        </Layout>
      </>
    );
  }
};

export default NewsPage;
